/**
 * Character limit for the user-provided names the backend stores in 100-character columns:
 * `class_members.name`, `school_classes.name` and the vocabulary training title.
 *
 * Going over it makes the backend fail with a data truncation error instead of a readable
 * validation message, so the inputs cap typing and the save paths clamp as a safety net.
 * Split this constant again if one of those columns ever gets its own limit.
 */
export const MAX_NAME_LENGTH = 100;

/**
 * Maximum number of students a single table upload may contain. Anything beyond this is not a
 * realistic class or school list and only risks slow imports and bad data, so the file is
 * rejected instead of being processed.
 */
export const MAX_UPLOADED_STUDENTS = 100;
